import { IconAlertTriangle, IconCheck, IconRefresh } from "@tabler/icons-react";
import type { CargarZipResultado } from "@/features/cargar-zip/types";
import { Alert, Button, Card, Divider, Group, Stack, Text, ThemeIcon } from "@/components/ui";
import { DescartesAccordion } from "./DescartesAccordion";

/**
 * Card-resumen del último upload de ZIP · presentacional.
 * Recopila las 3 secciones de diagnóstico: F6, descartes, reglas.
 */
export function DiagnosticoCard({ resultado }: { resultado: CargarZipResultado }) {
  const ok = resultado.f6Autorizada && resultado.reglasAutorizadas;
  return (
    <Card padding="lg" style={{ borderColor: `var(--color-${ok ? "exito" : "advertencia"}-400)`, background: `color-mix(in srgb, var(--color-${ok ? "exito" : "advertencia"}-600) 6%, transparent)` }}>
      <Stack gap="md">
        <DiagnosticoHeader resultado={resultado} ok={ok} />
        <Divider />
        <Stack gap="sm">
          {!resultado.f6Autorizada && resultado.f6MotivoRechazo && (
            <Alert variant="error" icon={<IconAlertTriangle size={16} stroke={1.7} />} title="F6 rechazado">
              {resultado.f6MotivoRechazo}
            </Alert>
          )}
          <DescartesAccordion descartes={resultado.descartes} />
          {resultado.erroresReglas.length > 0 && (
            <Stack gap={6}>
              <Text size="sm" fw={500}>
                Reglas rechazadas:
              </Text>
              {resultado.erroresReglas.map((e, i) => (
                <Alert key={i} variant="error" icon={<IconAlertTriangle size={14} stroke={1.7} />}>
                  <Group gap={6} wrap="nowrap">
                    <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{e.codigo}</code>
                    <Text size="sm">{e.mensaje}</Text>
                  </Group>
                </Alert>
              ))}
            </Stack>
          )}
          {!ok && (
            <Group justify="flex-end" className="mt-1">
              <Button variant="default" size="xs" leftSection={<IconRefresh size={14} />} onClick={() => window.location.reload()}>
                Cargar otro ZIP
              </Button>
            </Group>
          )}
        </Stack>
      </Stack>
    </Card>
  );
}

function DiagnosticoHeader({ resultado, ok }: { resultado: CargarZipResultado; ok: boolean }) {
  return (
    <Group gap="sm" align="flex-start">
      <ThemeIcon variant="filled" color={ok ? "exito" : "advertencia"} size="lg">
        {ok ? <IconCheck size={20} stroke={1.8} /> : <IconAlertTriangle size={20} stroke={1.7} />}
      </ThemeIcon>
      <div className="flex-1">
        <Text fw={600}>{ok ? "ZIP procesado correctamente" : "ZIP procesado con observaciones"}</Text>
        <Text size="sm" c="dimmed" className="mt-0.5">
          {resultado.cfdisViables} CFDIs viables · {resultado.descartes.length} descarte(s) · {resultado.archivosNoXmlNiPdfIgnorados} archivo(s) no XML/PDF ignorados.
        </Text>
      </div>
    </Group>
  );
}
